export class BreadcrumbProgressControl {
  titles: string[];
  progressIndex: number;
  isDisabled?: boolean[];
  constructor() {
    this.progressIndex = 0;
  }
}
